import type { ApiKeyQuestionAnswerClip } from "@app/common/types";

export const isProposedAnswer = (status: ApiKeyQuestionAnswerClip["status"]) =>
  !status || status === "read_active";
